<div class="flex items-center gap-3 bg-error-600 px-6 py-4 text-white" mat-dialog-title>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="shrink-0">
    <circle cx="12" cy="12" r="10" /><line x1="12" x2="12" y1="8" y2="12" /><line x1="12" x2="12.01" y1="16" y2="16" />
  </svg>
  <span class="text-base font-semibold leading-none">Algo deu errado</span>
</div>

<mat-dialog-content class="!px-6 !py-5 space-y-4">
  <p class="text-sm text-neutral-500">Desculpe o inconveniente. Detalhes do erro:</p>

  <div class="rounded-lg border border-neutral-200 bg-neutral-50 p-4 space-y-2.5
              dark:border-neutral-700 dark:bg-neutral-800">
    <div class="flex items-start gap-2 text-sm">
      <span class="min-w-24 font-medium text-neutral-700 dark:text-neutral-300">Status</span>
      <span class="text-neutral-600 dark:text-neutral-400">{{ data.status }}</span>
    </div>
    @if (data.error) {
    <div class="flex items-start gap-2 text-sm">
      <span class="min-w-24 font-medium text-neutral-700 dark:text-neutral-300">Erro</span>
      <span class="text-neutral-600 dark:text-neutral-400">{{ data.error }}</span>
    </div>
    }
    <div class="flex items-start gap-2 text-sm">
      <span class="min-w-24 font-medium text-neutral-700 dark:text-neutral-300">Mensagem</span>
      <span class="text-neutral-600 dark:text-neutral-400">{{ messageText }}</span>
    </div>
    @if (data.details?.length) {
    <div class="flex items-start gap-2 text-sm">
      <span class="min-w-24 font-medium text-neutral-700 dark:text-neutral-300">Detalhes</span>
      <ul class="list-disc list-inside space-y-0.5 text-neutral-600 dark:text-neutral-400">
        @for (detail of data.details; track detail) {
        <li>{{ detail }}</li>
        }
      </ul>
    </div>
    }
    <div class="flex items-start gap-2 text-sm">
      <span class="min-w-24 font-medium text-neutral-700 dark:text-neutral-300">Data</span>
      <span class="text-neutral-600 dark:text-neutral-400">
        {{ data.timestamp | date: 'dd/MM/yyyy HH:mm:ss' }}
      </span>
    </div>
    @if (data.path) {
    <div class="flex items-start gap-2 text-sm">
      <span class="min-w-24 font-medium text-neutral-700 dark:text-neutral-300">Rota</span>
      <span class="text-neutral-600 dark:text-neutral-400 font-mono text-xs">{{ data.path }}</span>
    </div>
    }
  </div>

  @if (data.data) {
  <div class="space-y-2">
    <button type="button" (click)="toggleDetails()"
      class="text-sm text-primary-600 hover:underline focus:outline-none cursor-pointer">
      {{ showDetails ? 'Ocultar Stack Trace ▲' : 'Mostrar Stack Trace ▼' }}
    </button>

    @if (showDetails) {
    <div class="space-y-2">
      <div class="max-h-48 overflow-auto rounded-lg border border-neutral-200 bg-neutral-100 p-3
                  dark:border-neutral-700 dark:bg-neutral-900">
        <pre class="whitespace-pre-wrap font-mono text-xs text-neutral-700 dark:text-neutral-300">{{ data.data }}</pre>
      </div>
      <button type="button" (click)="copyDetails()"
        class="text-sm text-primary-600 hover:underline focus:outline-none cursor-pointer">
        Copiar Stack Trace
      </button>
    </div>
    }
  </div>
  }
</mat-dialog-content>

<mat-dialog-actions class="!px-6 !py-4 justify-end bg-neutral-50 dark:bg-neutral-900/50">
  <button matButton="filled" type="button" (click)="close()">Fechar</button>
</mat-dialog-actions>
